<template>
    <div class="container-box">
        <div v-if="data.length === 0" class="blank-box">
            <img :src="$images.material.blank" alt="blank" />
            <span class="word">暂无数据</span>
        </div>
        <div v-else class="catalogs-box">
            <div
                v-for="(item1, index1) in data"
                :key="'item1'+index1"
                class="item-one">
                <p class="p-name">
                    <span class="name"
                          :class="{active: `${item1.id}` === `${newSelectCatalog}`}"
                          @click="handlerChange(item1.id)"
                    >{{item1.name}}</span>
                </p>
                <div class="group">
                    <p
                        v-for="(item2, index2) in item1.childrens"
                        class="name"
                        :class="{active: `${item2.id}` === `${newSelectCatalog}`}"
                        :key="'item2'+index2"
                    >
                        <span @click="handlerChange(item2.id)">{{item2.name}}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "catalogs-type-box",
        props: {
            data: Array,
            selectCatalog: [String, Number]
        },
        watch: {
            selectCatalog(vl) {
                this.newSelectCatalog = vl
            },
            newSelectCatalog(vl){
                this.$emit('update:selectCatalog', vl)
            }
        },
        mounted(){
        },
        data () {
            return {
                newSelectCatalog: this.selectCatalog
            }
        },
        methods: {
            handlerChange(vl){
                this.newSelectCatalog = vl
                this.$emit('success')
            }
        }
    }
</script>

<style lang="scss" scoped>
.blank-box{
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    margin: 30px 0px;
    flex-direction: column;

    .word {
        font-size:14px;
        font-weight:400;
        color:rgba(48,49,51,1);
        line-height:20px;
        position: relative;
        left: -6px;
        margin-top: 10px;
    }
}
.catalogs-box{
    display: flex;
    flex-direction: row;
    max-height: 100vh;
    padding: 30px 34px 20px;
    flex-wrap: wrap;

    .item-one{
        display: flex;
        flex-direction: column;
        margin-bottom: 6px;
        width: 200px;
        margin-right: 20px;

        .name:hover, .name.active{
            color: #FF7838 !important;
        }

        &>.p-name .name{
            font-size: 14px;
            font-weight: 500;
            color: #26282E;
            line-height: 20px;
            cursor: pointer;
        }

        .group{
            display: flex;
            flex-direction: row;
            align-items: center;
            flex-wrap: wrap;
            padding-top: 10px;

            &>.name{
                font-size: 12px;
                font-weight: 400;
                color: #8C8F97;
                line-height: 17px;
                margin-bottom: 10px;
                margin-right: 20px;
                cursor: pointer;
            }
        }
    }
}
</style>
